import { useQuery } from '@tanstack/react-query';
import { invalidateAll } from '../../api/queryClient';
import { trpc, type RouterOutputs } from '../../api/trpc';

export type AdminUser = RouterOutputs['auth']['users']['list'][number];

export function useUsers(enabled: boolean) {
  return useQuery(trpc.auth.users.list.queryOptions(undefined, { enabled }));
}

export function invalidateUsers(): Promise<void> {
  return invalidateAll(trpc.auth.users.pathFilter());
}
